<!--
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2022-11-23 10:08:42
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @LastEditTime: 2022-11-23 10:13:29
 * @FilePath: \daze-cloud-components\packages\modules\sourceList\commodity\components\noData.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="container">
        <img src="https://oss.fjdaze.com/oneKeyCopy1688/pdd/copy/drawer.png" />
        <div class="no-data">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoData',
};
</script>

<style scoped>
.container {
    margin: 0 auto;
    padding: 60px 0 60px 0;
    text-align: center;
}
.no-data {
    font-size: 14px;
    font-weight: bold;
    color: #4d4d4d;
    text-align: center;
}
</style>
